(function CartDrawerCustomization() {
  'use strict';

  const SELECTORS = {
    cartDrawer: 'cart-drawer',
    cartItems: 'cart-drawer-items .cart-item__link, cart-items .cart-item',
    view: 'customization-view',
    cartItemImageContainer: '.cart-item__image-container'
  };

  const cache = new Map();

  // --- Cache helpers ---

  async function fetchJSON(url) {
    if (cache.has(url)) return cache.get(url);

    const response = await fetch(url);
    if (!response.ok) throw new Error(`Fetch failed: ${url} (${response.status})`);

    const data = await response.json();
    cache.set(url, data);
    return data;
  }

  function invalidateCartCache() {
    cache.delete(window.Shopify.routes.root + 'cart.js');
  }

  // --- Core logic ---

  handleOpen();
  async function handleOpen() {
    invalidateCartCache(); // Always re-fetch cart, but cache product data

    const [cartItems, cart] = await Promise.all([
      Promise.resolve(Array.from(document.querySelectorAll(SELECTORS.cartItems))),
      fetchJSON(window.Shopify.routes.root + 'cart.js'),
    ]);

    const products = await Promise.all(
      cart.items.map(({ handle }) => fetchJSON(`/products/${handle}.js`))
    );

    cart.items.forEach((item, index) => {
      const productImages = products[index]?.images ?? [];
      const cartItemNode = cartItems[index];

      if (!cartItemNode) return;

      const matchingImages = productImages.filter((image) => {
        if (image.includes('logo')) return true;

        return Object.entries(item.properties).some(([key, val]) => {
          const value = val.replaceAll(' ', '_');
          return image.includes(key) && image.includes(value);
        });
      });

      matchingImages.forEach((image) => addImageToCart(image, cartItemNode));
    });
  }

  function addImageToCart(image, cartItemNode) {
    const src = image.replace('.png?', '_200x.png?');

    // Avoid duplicate images
    const alreadyAdded = Array.from(cartItemNode.querySelectorAll(`.${SELECTORS.view}`)).some((img) => img.src.endsWith(src));
    if (alreadyAdded) return;

    const targetNode = cartItemNode.querySelector(SELECTORS.cartItemImageContainer) || cartItemNode;

    const imgNode = document.createElement('img');
    imgNode.src = src;
    imgNode.classList.add(SELECTORS.view);
    targetNode.appendChild(imgNode);
  }

  // --- Event wiring ---

  function onMutation() {
    const drawer = document.querySelector(SELECTORS.cartDrawer);
    if (drawer?.classList.contains('active')) handleOpen();
  }

  const drawer = document.querySelector(SELECTORS.cartDrawer);
  if (drawer) {
    new MutationObserver(onMutation).observe(drawer, { attributes: true });
  }

  document.addEventListener('afterCartChanged', handleOpen);
  document.addEventListener('afterQuantityUpdate', handleOpen);
})();